import { BaseEntity } from "../entities";
import { ApiClient } from "./client"

export class SupportCaseProvider {
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/supportCase/${id}`) as SupportCase;
    }

    static async getAllByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/supportCase/by-organisation/all?organisationId=${organisationId}&page=${page}&size=${size}`) as SupportCase[];
    }

    static async getMyByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/supportCase/by-organisation/my?organisationId=${organisationId}&page=${page}&size=${size}`) as SupportCase[];
    }

    static async save(supportCase: SupportCase) {
        return await this._apiClient.post('/supportCase', supportCase) as number;
    }
}

export interface SupportCase extends BaseEntity {
    SupportCaseId: number
    SupportCaseAssignedTo: number
    SupportCaseOwnerId: number
    SupportCaseStatus: SupportCaseStatus
    SupportCaseChannel: number
    SupportCaseDeadline: string
    SupportCaseAction: string
    SupportCaseSubject: string
    SupportCaseTicket: string
    SupportCaseOrganisationId: number
    SupportCasePersonId: number
    SupportCasePersonName: string
}

export enum SupportCaseStatus {
    Created = 'Created',
    Ongoing = 'Ongoing',
    Closed = 'Closed',
}
